import moneyDisplay from "../../../../components/moneyDisplay/moneyDisplay";
import { connect } from "react-redux";
export default connect(state => ({
  value: state.revenue.allRevenues.totalRevenueYTD,
  url: state.revenue.allRevenues.totalRevenueYTDRawDataLink,
  currency: state.revenue.allRevenues.currencySymbol,
  size: 44,
  disableAnimation: state.revenue.currentUser.qa
}))(moneyDisplay);
